import { useState } from 'react'
import {
  useConfirmDialog,
  UseConfirmDialogProps
} from 'src/components/common/Modals/ConfirmDialog'

type DialogContentType = {
  header: string
  body: string | JSX.Element
}
export const useConfirmServerUpdateDialog = () => {
  const [dialogContent, setDialogContent] = useState<DialogContentType>({
    header: '',
    body: ''
  })
  const [renderDialog, methods] = useConfirmDialog()

  const onOpen = (dialogContent: DialogContentType) => {
    setDialogContent(dialogContent)
    methods.onOpen()
  }

  const renderDeleteDialog = (props: UseConfirmDialogProps) =>
    renderDialog({
      header: dialogContent.header,
      body: dialogContent.body,
      okButton: {
        onClick: props.okButton.onClick
      },
      cancelButton: {}
    })

  return [renderDeleteDialog, { ...methods, onOpen }] as const
}
